import {
  GET_INVITED_NUMBERS,
  FETCH_LOADING,
  FETCH_ERROR,
  SET_POPUP_STATUS,
  SET_ACTIVE_STEP,
  POPUP_LOADING,
  SET_NEW_LIMITS,
  CHANGE_INVITE_ITEMS,
  CHANGE_PROCESSING_STATUS,
  SET_PRICE_AFTER_DELETE_NUMBER,
} from './constants';
import { getInvitedNumbers } from '../api/getInvitedNumbers';
import { createInvite } from '../api/createInvite';
import { LIMIT_UNITS, POPUP_NAMES, ERROR_POPUP_TYPES } from '../constants';
import { saveLimits } from '../api/saveLimits';
import { deleteOrCancelCtn, getPriceAfterDelete } from '../api/deleteOrCancelCtn';
import { replaceObjectKeys } from '../utils';
import { isEmptyValue } from '../../../utils/common';

const getFamilyData = (object) => ({
  type: GET_INVITED_NUMBERS,
  payload: object,
});

const fetchLoading = (bool) => ({
  type: FETCH_LOADING,
  payload: bool,
});

const fetchError = (bool) => ({
  type: FETCH_ERROR,
  payload: bool,
});

const setPopupStatus = (bool) => ({
  type: SET_POPUP_STATUS,
  payload: bool,
});

const setActiveStep = (string) => ({
  type: SET_ACTIVE_STEP,
  payload: string,
});

const fetchPopupLoading = (bool) => ({
  type: POPUP_LOADING,
  payload: bool,
});

const setNewLimits = (object) => ({
  type: SET_NEW_LIMITS,
  payload: object,
});

const changeInviteItems = (string) => ({
  type: CHANGE_INVITE_ITEMS,
  payload: string,
});

const changeInviteIsProcessing = (string) => ({
  type: CHANGE_PROCESSING_STATUS,
  payload: string,
});

const setPriceAfterDeleteNumber = (obj) => ({
  type: SET_PRICE_AFTER_DELETE_NUMBER,
  payload: obj,
});

const newPriceInfoAfterDeleteNumber = (ctn, childCtn) => async (dispatch) => {
  dispatch(fetchPopupLoading(true));
  try {
    const response = await getPriceAfterDelete(ctn, childCtn);
    const incomingData = response.data.result;

    if (response.data.isSucceeded && !isEmptyValue(incomingData)) {
      dispatch(setPriceAfterDeleteNumber(incomingData));
      return;
    }
  } catch (error) {
    console.error('Couldn\'t load info from -  getPriceAfterDelete(): ', error);
  } finally {
    dispatch(fetchPopupLoading(false));
  }
};

const fetchManageFamilyData = () => async (dispatch) => {
  try {
    dispatch(fetchLoading(true));
    const response = await getInvitedNumbers();
    dispatch(getFamilyData(response.data));
  } catch (error) {
    dispatch(fetchError(true));
    console.error(error);
  } finally {
    dispatch(fetchLoading(false));
  }
};

const createInviteToFamily = (ctn) => async (dispatch) => {
  try {
    dispatch(fetchPopupLoading(true));
    const response = await createInvite(ctn);
    if (response.data.isSucceeded) {
      await fetchManageFamilyData();
      dispatch(setActiveStep(POPUP_NAMES.addedSuccessfully));
    } else {
      if (response?.data?.error?.message in ERROR_POPUP_TYPES) {
        dispatch(setActiveStep(ERROR_POPUP_TYPES[response?.data?.error?.message]));
        return;
      }
      dispatch(setActiveStep(POPUP_NAMES.error));
    }
  } catch (error) {
    dispatch(setActiveStep(POPUP_NAMES.error));
    console.error(error);
  } finally {
    dispatch(fetchPopupLoading(false));
  }
};

const saveNewChildLimits = () => async (dispatch, getState) => {
  try {
    dispatch(fetchPopupLoading(true));

    const { family: { newLimits } } = getState();
    const formatNewLimits = replaceObjectKeys(newLimits, LIMIT_UNITS);
    const response = await saveLimits(formatNewLimits);

    if (response.data.isSucceeded) {
      dispatch(setActiveStep(POPUP_NAMES.limitsSavedSuccess));
      return;
    }
    dispatch(setActiveStep(POPUP_NAMES.error));
  } catch (error) {
    dispatch(setActiveStep(POPUP_NAMES.error));
    console.error(error);
  } finally {
    dispatch(fetchPopupLoading(false));
  }
};

const deleteOrCancelChosenCtn = (ctn, flag = true) => async (dispatch) => {
  try {
    dispatch(fetchPopupLoading(true));

    const response = await deleteOrCancelCtn(ctn, flag);

    if (response.data.isSucceeded) {
      dispatch(setActiveStep(POPUP_NAMES.deleteSuccess));
      return;
    }
    dispatch(setActiveStep(POPUP_NAMES.error));
  } catch (error) {
    dispatch(setActiveStep(POPUP_NAMES.error));
    console.error(error);
  } finally {
    dispatch(fetchPopupLoading(false));
  }
};

export {
  fetchManageFamilyData,
  setPopupStatus,
  setActiveStep,
  setNewLimits,
  createInviteToFamily,
  saveNewChildLimits,
  deleteOrCancelChosenCtn,
  changeInviteItems,
  changeInviteIsProcessing,
  newPriceInfoAfterDeleteNumber,
};
